export default __webpack_public_path__ + "static/media/pexels-vinicius-benedit-1082343.3b76cd6b.jpg";